import React from 'react';
import moment from 'moment';

import { FormattedMessage } from '../../util/reactIntl';

import { createRewildingInfoLinks } from '../../util/api';

import { FieldCheckbox, IconDelete, IconEye } from '../index';

import css from './RewildingInfoBox.module.css';

const FilesBox = props => {
  const { files, flow, onRemoveRewildingInfoFile = () => {}, removeFileInProgress = false } = props;

  const openRewildingInfoFile = async (e, item) => {
    e.preventDefault();

    try {
      const { key } = item;

      const { links = [] } = await createRewildingInfoLinks({
        blobNames: [key],
      });

      const url = links[0]?.link;

      if (!url) {
        console.error('No link returned for file:', item);
        return;
      }

      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Failed to open rewilding info file', error);
    }
  };

  return (
    <div className={css.filesBox}>
      <div className={css.filesBoxTitle}>
        <div className={css.filesBoxHead}>
          <FormattedMessage id="RewildingInfoBox.rewildingInfoName" />
        </div>
        <div className={css.filesBoxHeadFormat}>
          <FormattedMessage id="RewildingInfoBox.rewildingInfoFormat" />
        </div>
        <div className={css.filesBoxHead}>
          <FormattedMessage id="RewildingInfoBox.rewildingInfoCreated" />
        </div>
        <div className={css.filesBoxHead}>
          <FormattedMessage id="RewildingInfoBox.rewildingInfoActions" />
        </div>
      </div>
      {files.map(item => {
        return (
          <div key={item.key} className={css.file}>
            <div className={css.filesBoxColumn}>{item.name}</div>
            <div className={css.filesBoxColumnFormat}>{item.format.toUpperCase()}</div>
            <div className={css.filesBoxColumn}>
              {moment(item.createdAt).format('MMMM D, YYYY')}
            </div>
            <div className={css.filesBoxColumn}>
              <button onClick={e => openRewildingInfoFile(e, item)} className={css.button}>
                <IconEye />
              </button>
              {flow === item.createdBy ? (
                <button
                  onClick={e => onRemoveRewildingInfoFile({ key: item.key })}
                  className={css.button}
                  disabled={removeFileInProgress}
                >
                  <IconDelete />
                </button>
              ) : (
                <FieldCheckbox
                  id={item.key}
                  name={`rewildingInfoFile_${item.key}`}
                  className={css.checkbox}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FilesBox;
